<template>
<div id="wrapper" :key="valuekey">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.approve.fleet.driver.label.title')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>
               <p class="sub-header">
                    {{$t('string.msg.approve.truck.driver.label.description')}}
                </p>
              
                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.trucker.table.header.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.trucker.label.phone')}}</th>
                                <!--<th class="border-top-0">{{$t('string.msg.trucker.table.header.document')}}</th>
                                <th class="border-top-0">{{$t('string.msg.trucker.table.header.cnh')}}</th>
                                <th class="border-top-0">{{$t('string.msg.trucker.table.header.email')}}</th>-->
                                <th class="border-top-0">{{$t('string.msg.trucker.table.header.photo')}}</th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                            <tr>
                                <td>
                                    <span>
                                        {{item.firstName + ' ' + item.lastName }}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{item.primaryPhone}}
                                    </span>
                                </td>
                                <!--<td>
                                    <span>
                                        <input readonly class="form-control reset-input" :value="item.customerUser.document" v-mask="['###.###.###-##']">
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{item.customerUser.cnh}}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{item.email}}
                                    </span>
                                </td>-->
                                 <td>
                                    <img v-if="item.customerUser && item.customerUser.cnhPhotoURL!= 'https://semfoto'" v-bind:src="`${domain}${item.customerUser.cnhPhotoURL}`" alt="image" height="100" width="130">
                                    <span v-else> {{$t('string.msg.trucker.dont.have.photo')}}</span>
                                </td>
                             
                            </tr>
                        </tbody>
                    </table>
                </div>{{data}}
            </div>
        </div>
        <ModalPhoto :item="item" v-on:confirmation-return="showMesage" />
        <FlashMessage/>
    </div>
</div>
</template>

<script>
import Controller from './CrtListTrucker';
import ModalPhoto from './Modal/ModalPhoto';
import Vue from 'vue'
import crono from 'vue-crono';
Vue.use(crono);

export default {
  name: 'ListTrucker',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    ModalPhoto
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        item: {},
        timer: '',
        filters: {
            company: null,
            statusWithCompany: "WAITING_FOR_APPROVAL"
        },
        newTrucker: false,
        totalTruckers:0
      }
  },    
  methods: Controller.methods,
  created() {
  },
  mounted(){
      Controller.init(this);
  },
  cron:{
        time: 45000,
        method: 'load'
    },
  destroyed(){
    clearInterval(this.time);
  },
  beforeDestroy () {
    clearInterval(this.time);
  }
}
</script>


